export default "__VITE_ASSET__e43fac43__"